var map = {
	"./1.png": [
		69942,
		9942
	],
	"./2.png": [
		60621,
		3002
	],
	"./3.png": [
		18116
	],
	"./4.png": [
		28059
	],
	"./next.png": [
		26140,
		6140
	],
	"./prev.png": [
		85336,
		5336
	],
	"./wok_add_sauce.png": [
		6282,
		6282
	],
	"./wok_meat.png": [
		32742,
		2742
	],
	"./wok_topping.png": [
		38962,
		8962
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79879;
module.exports = webpackAsyncContext;